export default __webpack_public_path__ + "static/media/PORThero.9ddf6013.jpg";